import { Route, Switch } from "react-router-dom";
import { LinkedInPopUp } from "react-linkedin-login-oauth2";

import {
  HOME,
  CERTAIN_TOPIC,
  NO_MATCH_404_PAGE,
  REGISTER,
  LOG_IN,
  LINKED_IN,
  SEARCH_BY_TEXT,
  GET_DOCUMENT_BY_ID,
  GROUP_OF_TILES_BY_ID,
} from "../../constants/stringConstants";

import Header from "../HeaderComponents/Header";
import HomePageContainer from "../HomePageComponents/HomePageContainer";
import TopicHomePageContainer from "../TopicComponents/TopicHomePageContainer";
import NoMatchPage from "../../utils/NoMatchPage";
import RegisterContainer from "../RegisterComponents/RegisterContainer";
import LogInContainer from "../LogInComponents/LogInContainer";
import SearchTopicContainer from "../SearchComponents/SearchTopicContainer";
import DocumentContainer from "../DocumentComponents/DocumentContainer";
import CardAssessmentContainer from "../../utils/CardCustomComponents/CardAssessmentContainer";

const MainAppContainer = () => {
  return (
    <>
      <Header />
      <Switch>
        <Route exact path={HOME} component={HomePageContainer} />
        <Route path={CERTAIN_TOPIC} component={TopicHomePageContainer} />
        <Route path={REGISTER} component={RegisterContainer} />
        <Route path={LOG_IN} component={LogInContainer} />
        <Route path={LINKED_IN} component={LinkedInPopUp} />
        <Route path={SEARCH_BY_TEXT} component={SearchTopicContainer} />
        <Route path={GET_DOCUMENT_BY_ID} component={DocumentContainer} />
        <Route
          path={GROUP_OF_TILES_BY_ID}
          component={CardAssessmentContainer}
        />
        <Route path={NO_MATCH_404_PAGE} component={NoMatchPage} />
      </Switch>
    </>
  );
};

export default MainAppContainer;
